/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _cloneDeep from 'lodash/cloneDeep';
import { Analytics } from '../../../../analytics/sendAnalyticsEvent';
import { generateAnalyticsInteractionEvent } from '../utils/generateAnalyticsInteractionEvent';

export default (set, get, payload) => {
  const { target } = payload;
  set(
    produce(get(), (draft) => {
      if (!draft.digitalData) {
        draft.digitalData = { event: [] };
      }
      const section = 'choose cabinet collection';
      const event = generateAnalyticsInteractionEvent(section, target);

      const eventClone = _cloneDeep(event);
      draft.digitalData.event.push(event);
      Analytics.sendAnalyticsEvent(eventClone);
    }),
    false,
    { type: 'COLLECTION_VIEW_DETAILS_EVENT' }
  );
};